module.exports = __webpack_public_path__ + "static/media/sigma.480ab02a.png";